const cart = {
    state: {
        cart: localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : []
    },
    mutations: {
        ADD_TO_CART(state, product) {
            state.cart.push(product)
            localStorage.setItem('cart', JSON.stringify(state.cart))
        },
        CHANGE_PRODUCT_COUNT(state, {index, product}) {
            state.cart[index].count = product.count;
            localStorage.setItem('cart', JSON.stringify(state.cart))
        },
        REMOVE_PRODUCT(state, index) {
            state.cart.splice(index, 1)
            localStorage.setItem('cart', JSON.stringify(state.cart))
        },
        CHANGE_CART(state, products) {
            state.cart = products
            localStorage.setItem('cart', JSON.stringify(state.cart))
        },
        EMPTY_CART(state) {
            state.cart = []
            localStorage.setItem('cart', JSON.stringify(state.cart))
        },
    },
    actions: {
        addToCart({commit, state}, product) {
            let index = state.cart.findIndex((item) => product.id === item.id)

            if (index > -1) {
                commit('CHANGE_PRODUCT_COUNT', {index, product})
            } else {
                commit('ADD_TO_CART', product)
            }
        },
        removeProduct({commit, state}, product) {
            let index = state.cart.findIndex((item) => product.id === item.id)
            if (index > -1) {
                commit('REMOVE_PRODUCT', product)
            }
        },
        changeCart({commit}, products) {
            commit('CHANGE_CART', products)
        },
        emptyCart({commit}) {
            commit('EMPTY_CART')
        },
    },
    getters: {
        productCount: state => id => {
            const product = state.cart.find(product => product.id === id)
            if (product) {
                return product.count
            }

            return 0;
        },
        productDescription: state => id => {
            const product = state.cart.find(product => product.id === id)
            if (product) {
                return product.orderDescription
            }

            return ''
        },
        cartCount(state) {
            return state.cart.length
        },
        cartPrice(state) {
            return state.cart.reduce((totalPrice, product) =>
                    totalPrice += product.price * product.count
                , 0)
        },
    }
}

export default cart;
